module.exports = __webpack_public_path__ + "static/f2c-furniture-opportunity-1bbf28355f7981752dbc6608e4c7d186.jpg";